module.exports = __webpack_public_path__ + "img/2.734fe87e.jpg";